/**
 * Dons of Gin — Scroll-Aware Header.
 * Manages smooth background transitions for the sticky header
 * based on the currently visible section.
 */

(() => {
  const header = document.querySelector("header-component");
  if (!header) {
    return;
  }

  // Configuration: Threshold for when a section is considered "active" for the header
  const threshold = 0.1;

  const observerOptions = {
    root: null,
    rootMargin: "-80px 0px 0px 0px", // Offset for header height
    threshold,
  };

  const handleIntersection = (entries) => {
    // If we are at the very top, always stay transparent
    if (window.scrollY < 50) {
      header.dataset.activeColorScheme = "transparent";
      return;
    }

    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const section = entry.target;

        // Find the color scheme class on the section or its children
        let colorScheme = null;
        const schemeMatch = section.className.match(/color-(scheme-\w+)/);

        if (schemeMatch) {
          colorScheme = schemeMatch[1];
        } else if (section.querySelector('[class*="color-scheme-"]')) {
          const innerMatch = section
            .querySelector('[class*="color-scheme-"]')
            .className.match(/color-(scheme-\w+)/);
          if (innerMatch) {
            colorScheme = innerMatch[1];
          }
        }

        if (
          section.classList.contains("hero-grid") ||
          section.querySelector(".hero-grid")
        ) {
          header.dataset.activeColorScheme = "transparent";
        } else if (colorScheme) {
          header.dataset.activeColorScheme = colorScheme;
        } else {
          header.dataset.activeColorScheme = "default";
        }
      }
    });
  };

  const observer = new IntersectionObserver(
    handleIntersection,
    observerOptions
  );

  // Observe all major sections
  document
    .querySelectorAll("main section, main .shopify-section")
    .forEach((section) => {
      observer.observe(section);
    });
})();
